import { PathLayer, PathLayerProps } from "@deck.gl/layers"
import type { DefaultProps } from "@deck.gl/core"
import { TerrainExtensionProps } from "@deck.gl/extensions"
import type { VideoMetadata } from "@nova/slice-video"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

type VideoPathLayerData = {
    path: VideoMetadata[]
}

type VideoPathLayerProps<DataType = VideoPathLayerData> = PathLayerProps<DataType> &
    TerrainExtensionProps

const defaultProps: DefaultProps = {
    pickable: false,
    getPath: (d: VideoPathLayerData) => {
        const dimensions = getGlobalTerrainData().terrainState ? 3 : 2
        return d.path.map((point) => point.slice(0, dimensions))
    },
    getColor: [30, 109, 169, 191],
    widthUnits: "pixels",
    getWidth: () => 3,
    visible: true,
}

export default class FlightPathsLayer<
    DataType = VideoPathLayerData,
    ExtraPropsType extends PathLayerProps<DataType> = VideoPathLayerProps<DataType>,
> extends PathLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "VideoPathsLayer"
}
